import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyDiXg53kJY1bGk7_PtRDMk0A0wEewO2vSY",
    authDomain: "production-tracking-45852.firebaseapp.com",
    databaseURL: "https://production-tracking-45852.firebaseio.com",
    projectId: "production-tracking-45852",
    storageBucket: "production-tracking-45852.appspot.com",
    messagingSenderId: "168195825457",
    appId: "1:168195825457:web:5a59295447c9710ee91a10",
    measurementId: "G-8QR6LR48ZT"
  };

firebase.initializeApp(firebaseConfig);
export default firebase;